import {

    // FETCH_SELECTED_LINK_REQUEST,
    // FETCH_SELECTED_LINK_SUCCESS,
    // FETCH_SELECTED_LINK_FAILURE,
    SET_SELECTED_LINK_REQUEST,
    SET_SELECTED_LINK_SUCCESS,
    SET_SELECTED_LINK_FAILURE
} from '../actions/actionTypes';

const initialState = {
    // fetchDocumentsLoading: false,
    // uploadDocumentLoading: false,
    // deleteDocumentLoading: false,
    // fetchDocPreviewLoading: false,
    // renameDocLoading: false,
    // saveDocLoading: false,
    // documents: [],
    // selectedNode: null,
    // selectedItemParentId: null,
    // previewData: null,
    // folderList: [],
    // error: null,
    // uploadProgress: 0,
    // zeroLevelDataLoading: false,
    // parentSelected: null,
    // fetchFileSectionsLoading: false,
    // fileSections: [],
    sideBar: null,
    selectedLinkLoading: false
};

const sideBarReducer = (state = initialState, action) => {
    switch (action.type) {
        //Get selected side bar link
        // case FETCH_SELECTED_LINK_REQUEST:
        //     return { ...state, selectedLinkLoading: true, error: null };
        // case FETCH_SELECTED_LINK_SUCCESS:
        //     return { ...state, selectedLinkLoading: false, sideBar: action.payload };
        // case FETCH_SELECTED_LINK_FAILURE:
        //     return { ...state, selectedLinkLoading: false, error: action.error };

        //Set selected side bar link
        case SET_SELECTED_LINK_REQUEST:
            return { ...state, selectedLinkLoading: true, error: null };
        case SET_SELECTED_LINK_SUCCESS:
            return { ...state, selectedLinkLoading: false, sideBar: action.payload };
        case SET_SELECTED_LINK_FAILURE:
            return { ...state, selectedLinkLoading: false, error: action.error };

        default:
            return state;
    }
};

export default sideBarReducer;
